<template lang="pug" src='./custom-why-testimonials.pug'></template>

<script>
import Icon from 'components/icon/icon'
import { openModal } from '@/methods'

export default {
  data () {
    return {
      modalActive: false,
      videoTestimonial: '',
      swiperOption: {
        speed: 750,
        spaceBetween: 64,
        autoplay: {
          delay: 5000
        },
        pagination: {
          el: '.custom-why-testimonials__pagination',
          clickable: true
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  props: ['props'],
  mixins: [openModal],
  components: {
    Icon
  },
  methods: {
    openTestiModial (src) {
      this.modalActive = true
      this.videoTestimonial = src
    },
    closeTestiModial () {
      this.modalActive = false
      this.videoTestimonial = ''
    },
    slidePrev () {
      this.swiper.slidePrev()
    },
    slideNext () {
      this.swiper.slideNext()
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-why-testimonials.vue?099ad9f2